import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { useState } from 'react'
import Error from './pages/Error/Error'
import SharedLayout from './pages/SharedLayout/SharedLayout'
import Dashboard from './pages/Dashboard/Dashboard'
import Login from './pages/Login/Login'
import ProtectedRoute from './pages/ProtectedRoute/ProtectedRoute'
import { Toaster } from 'react-hot-toast'
import VetEvalForm from './pages/VetEvalForm/VetEvalForm'
import Myaccount from './pages/MyAccount/Myaccount'
import Emailverify from './pages/EmailVerify/Emailverify'
import PublicRoute from './pages/PublicRoute/PublicRoute'
import ForgotPassword from './pages/ForgotPassword'
import Loader from './components/Loader/loader'
import {
    BASE_ROUTE_ENDPOINTS,
    NAVIGATION_LINKS,
} from './constants/routeConstants'
import EvaluationLetterForm from './pages/EvaluationLetterForm/EvaluationLetterForm'
import ForgotPasswordForTmdsas from './pages/ForgotPasswordForTmdsas'
import Register_TMD from './pages/Registration-Tmdsas/Register_TMD'
import Register_JAMP from './pages/Registration-JAMP/Register_JAMP'
import UpdateProfile from './pages/UpdateProfile/UpdateProfile'

function App() {
    const [loadingData, setLoadingData] = useState(false)
    return (
        <BrowserRouter>
            <Toaster />
            <Loader open={loadingData} />
            <Routes>
                <Route
                    path={BASE_ROUTE_ENDPOINTS.LOGIN}
                    element={<SharedLayout />}>
                    <Route
                        path={BASE_ROUTE_ENDPOINTS.LOGIN}
                        element={
                            <PublicRoute>
                                <Login setLoadingDataGlobal={setLoadingData} />
                            </PublicRoute>
                        }
                    />
                    <Route
                        path={`${BASE_ROUTE_ENDPOINTS.VETEVALFORM}/:id`}
                        element={
                            <ProtectedRoute>
                                <VetEvalForm />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={BASE_ROUTE_ENDPOINTS.REGISTER}
                        element={
                            <PublicRoute>
                                <Emailverify
                                    setLoadingDataGlobal={setLoadingData}
                                />
                            </PublicRoute>
                        }
                    />

                    <Route
                        path={`${BASE_ROUTE_ENDPOINTS.EVALLETTERFORM}/:id`}
                        element={
                            <ProtectedRoute>
                                <EvaluationLetterForm
                                    setLoadingDataGlobal={setLoadingData}
                                />
                            </ProtectedRoute>
                        }
                    />

                    <Route
                        path={BASE_ROUTE_ENDPOINTS.DASHBOARD}
                        element={
                            <ProtectedRoute>
                                <Dashboard
                                    setLoadingDataGlobal={setLoadingData}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={BASE_ROUTE_ENDPOINTS.MYACCOUNT}
                        element={
                            <ProtectedRoute>
                                <Myaccount />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={BASE_ROUTE_ENDPOINTS.UPDATEPROFILE}
                        element={
                            <ProtectedRoute>
                                <UpdateProfile
                                    setLoadingDataGlobal={setLoadingData}
                                />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path={BASE_ROUTE_ENDPOINTS.FORGOTPASSWORD}
                        element={
                            <PublicRoute>
                                <ForgotPassword />
                            </PublicRoute>
                        }
                    />

                    <Route path="*" element={<Error />} />
                </Route>
                <Route
                    path={NAVIGATION_LINKS.FORGOTPASSWORDTMDSAS}
                    element={
                        <PublicRoute>
                            <ForgotPasswordForTmdsas />
                        </PublicRoute>
                    }
                />
                <Route
                    path={NAVIGATION_LINKS.REGISTER_TMD}
                    element={
                        <PublicRoute>
                            <Register_TMD
                                setLoadingDataGlobal={setLoadingData}
                            />
                        </PublicRoute>
                    }
                />
                <Route
                    path={NAVIGATION_LINKS.REGISTER_JAMP}
                    element={
                        <PublicRoute>
                            <Register_JAMP
                                setLoadingDataGlobal={setLoadingData}
                            />
                        </PublicRoute>
                    }
                />
            </Routes>
        </BrowserRouter>
    )
}

export default App
